import { getToken } from "../utils/clerk";

export const prepareHeaders = async (headers: Headers): Promise<Headers> => {
  // Get a fresh token from Clerk for each request
  const token = await getToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  headers.set("Content-Type", "application/json");
  return headers;
};
